import { render, staticRenderFns } from "./baseCrumbs.vue?vue&type=template&id=b11362a6&scoped=true"
import script from "./baseCrumbs.vue?vue&type=script&lang=js"
export * from "./baseCrumbs.vue?vue&type=script&lang=js"
import style0 from "./baseCrumbs.vue?vue&type=style&index=0&id=b11362a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11362a6",
  null
  
)

export default component.exports